import { ToastError as toastError } from "components/Global/Toasts/Toasty";
import _ from "lodash";
import { takeLatest, put } from "redux-saga/effects";
import { defaultReturn, generateDefaultActions, makeWritePayload, makePayload, requestSaga } from "shared-utility/store/utils/helpers";

const SET_RENT_ROLL_FIELD_SELECTIONS = generateDefaultActions("SET_RENT_ROLL_FIELD_SELECTIONS");
const setRentRollFieldSelections = payload => makeWritePayload(SET_RENT_ROLL_FIELD_SELECTIONS.value, payload);

const SET_SELECTIONS_TO_DEFAULT = generateDefaultActions("SET_SELECTIONS_TO_DEFAULT");
const setRentRollSelectionsToDefault = payload => makeWritePayload(SET_SELECTIONS_TO_DEFAULT.value, payload);

export const POST_RENT_ROLL_FIELD = generateDefaultActions("POST_RENT_ROLL_FIELD");
export const postRentRollField = payload => makePayload(POST_RENT_ROLL_FIELD.value, payload);
function* postRentRollFieldSaga({ data }) {
  const url = "/fields";
  yield requestSaga(POST_RENT_ROLL_FIELD, url, "POST", data, null, null, true);
}
export const SET_FIELD_UPDATED_FLAG = generateDefaultActions("SET_FIELD_UPDATED_FLAG");
export const PUT_RENT_ROLL_FIELD = generateDefaultActions("PUT_RENT_ROLL_FIELD");
export const putRentRollField = payload => makePayload(PUT_RENT_ROLL_FIELD.value, payload);
function* putRentRollFieldSaga({ data }) {
  const url = "/fields";
  yield requestSaga(PUT_RENT_ROLL_FIELD, url, "PUT", data, null, null, true);
  yield put(SET_FIELD_UPDATED_FLAG.createSuccess(true));
}

export const GET_RATE_CALCULATED_DATA = generateDefaultActions("GET_RATE_CALCULATED_DATA");
export const getRateCalculatedData = payload => makePayload(GET_RATE_CALCULATED_DATA.value, payload);
function* getRateCalculatedDataSaga({ data }) {
  const url = "/lrd/rent-rolls/v2";
  yield requestSaga(GET_RATE_CALCULATED_DATA, url, "POST", data);
}

export const GET_RENT_ROLL_OVERRIDES = generateDefaultActions("GET_RENT_ROLL_OVERRIDES");
export const getRentRollOverrides = payload => makePayload(GET_RENT_ROLL_OVERRIDES.value, payload);
function* getRentRollOverrideSaga({ data }) {
  const url = "/rent-rolls/overrides";
  yield requestSaga(GET_RENT_ROLL_OVERRIDES, url, "POST", data, null, null, true);
}

export const GET_RENT_ROLL_CHARGE_CODES = generateDefaultActions("GET_RENT_ROLL_CHARGE_CODES");
export const getRentRollChargeCodes = payload => makePayload(GET_RENT_ROLL_CHARGE_CODES.value, payload);
function* getRentRollChargeCodesSaga({ propertyId, dealId }) {
  const url = `/rent-rolls/property/${dealId}/${propertyId}`;
  yield requestSaga(GET_RENT_ROLL_CHARGE_CODES, url, "GET", null, null, null, true);
}

const initialState = {
  actualVacancyType: null,
  calculationPeriod: null,
  existingOverrides: null,
  pendingOverrides: null,
  fieldName: "",
  fieldValue: null,
  isAnnualized: true,
  isAnythingWasUpdated: false,
  isCalculatedDataLoading: false,
  isSavingField: false,
  isStep2Screen: false,
  manualEntryRentPerSqFt: null,
  marketRentType: null,
  maxMonthValidation: null,
  minimumVacancyRate: null,
  overrideOccupiedMonths: null,
  overrideVacantMonths: null,
  rateCalculationData: null,
  selectedParametersForLogs: null,
  selectedProperty: null,
  selectedRentRollField: null,
  shouldOverrideOccupied: false,
  shouldOverrideVacant: false,
  isOverrideVacantIncluded: true,
  vacancyRateType: "actual",
  rentRollChargeCodes: null,
  selectedChargeCodes: null,
  selectedFreeRentChargeCodes: null,
  isChargeCodesLoading: false,
  isChargeCodesAliasesLoading: false,
  vacantSuiteDefault: null,
  chargeCodeAliases: null,
  showConfirmationModal: false,
  locationModalIsOpenFrom: null,
  defaultInclude: false,
  shouldReplaceRentRollStepByMonths: false,
  replaceRentRollStepByMonths: null,
  shouldUseFreeRentChargeCodeByMonths: false,
  freeRentChargeCodeByMonths: null,
  isStraightLine: false
};

export const actionCreators = {
  setRentRollFieldSelections,
  setRentRollSelectionsToDefault,
  postRentRollField,
  putRentRollField,
  getRateCalculatedData,
  getRentRollOverrides,
  getRentRollChargeCodes
};

export function rentRollFieldReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_RENT_ROLL_FIELD_SELECTIONS.value:
      return defaultReturn({ ...state, ...payload });

    case SET_SELECTIONS_TO_DEFAULT.value: {
      return { ...initialState };
    }

    case GET_RENT_ROLL_CHARGE_CODES.failure:
      toastError("Failed to get rent roll charge codes");
      return defaultReturn({ ...state, isChargeCodesLoading: false }, null, "rentRollChargeCodes");

    case GET_RENT_ROLL_CHARGE_CODES.success: {
      const uniqueChargeCodesWithType = [];
      payload && payload.forEach(suite => {
        const leases = suite.leases;
        leases && leases.forEach(lease => {
          const scheduledRents = lease.scheduledRents;
          scheduledRents && scheduledRents.forEach(rent => {
            if (rent.chargeCode && rent.chargeType && !uniqueChargeCodesWithType.find(x => x.chargeCode === rent.chargeCode && x.chargeType === rent.chargeType)) {
              uniqueChargeCodesWithType.push({chargeCode: rent.chargeCode, chargeType: rent.chargeType});
            }
          });
        });
      });
      return defaultReturn({ ...state, isChargeCodesLoading: false }, uniqueChargeCodesWithType, "rentRollChargeCodes");
    }
    case GET_RENT_ROLL_CHARGE_CODES.value:
      return defaultReturn({ ...state, isChargeCodesLoading: true });

    case POST_RENT_ROLL_FIELD.success:
      return defaultReturn({
        ...state,
        isSavingField: false,
        isStep2Screen: true,
        selectedRentRollField: payload.data,
        isAnythingWasUpdated: false,
        showConfirmationModal: false
      });
    case POST_RENT_ROLL_FIELD.failure:
      toastError("Failed to save field");

      return defaultReturn({ ...state, isSavingField: false, showConfirmationModal: false });
    case POST_RENT_ROLL_FIELD.value:
      return defaultReturn({ ...state, isSavingField: true });

    case PUT_RENT_ROLL_FIELD.success:
      return defaultReturn({
        ...state,
        isSavingField: false,
        selectedRentRollField: payload.data,
        isAnythingWasUpdated: false,
        isStep2Screen: !state.isStep2Screen,
        showConfirmationModal: false
      });
    case PUT_RENT_ROLL_FIELD.failure:
      toastError("Failed to update field");

      return defaultReturn({ ...state, isSavingField: false, selectedRentRollField: null, showConfirmationModal: false });
    case PUT_RENT_ROLL_FIELD.value:
      return defaultReturn({ ...state, isSavingField: true });

    case GET_RATE_CALCULATED_DATA.success: {
      if (payload.suites) {
        const sortedSuites = payload.suites ? _.orderBy(payload.suites, ["name"]) : [];

        return defaultReturn({ ...state, isCalculatedDataLoading: false, rateCalculationData: { ...payload, suites: sortedSuites }});
      }
      const sortedSuites = payload.data?.suites ? _.orderBy(payload.data.suites, ["name"]) : [];

      return defaultReturn({ ...state, isCalculatedDataLoading: false, rateCalculationData: { ...payload.data, suites: sortedSuites } });
    }
    case GET_RATE_CALCULATED_DATA.failure:
      toastError("Failed to calculate vacancy rate");

      return defaultReturn({ ...state, isCalculatedDataLoading: false, rateCalculationData: null, isAnythingWasUpdated: false });
    case GET_RATE_CALCULATED_DATA.value:
      return defaultReturn({ ...state, isCalculatedDataLoading: true });

    case GET_RENT_ROLL_OVERRIDES.success: {
      return defaultReturn({ ...state, existingOverrides: payload.data });
    }
    case GET_RENT_ROLL_OVERRIDES.failure:
      toastError("Failed to update calculation parameters");

      return defaultReturn({ ...state, existingOverrides: null });
    case GET_RENT_ROLL_OVERRIDES.value:
      return defaultReturn({ ...state });

    default:
      return state;
  }
}

export function* rentRollFieldSaga() {
  yield takeLatest(POST_RENT_ROLL_FIELD.value, postRentRollFieldSaga);
  yield takeLatest(PUT_RENT_ROLL_FIELD.value, putRentRollFieldSaga);
  yield takeLatest(GET_RATE_CALCULATED_DATA.value, getRateCalculatedDataSaga);
  yield takeLatest(GET_RENT_ROLL_OVERRIDES.value, getRentRollOverrideSaga);
  yield takeLatest(GET_RENT_ROLL_CHARGE_CODES.value, getRentRollChargeCodesSaga);
}
